<template>
  <div class="detail-avod">
    <div class="detail-avod__banner">
      <div v-if="imgLoaded" class="detail-avod__banner__action">
        <div class="detail-avod__banner__action__save">
          <button class="btn-regular secondary">
           <i class="adx-ic_plus"></i>
           <span>Save</span>
          </button>
        </div>
        <div class="detail-avod__banner__action__viewphoto">
          <button class="btn-regular secondary" @click="toggle" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <div v-else class="detail-avod__banner__noaction">
        <div class="detail-avod__banner__noaction__viewphoto">
          <button class="btn-regular secondary" @click="toggle" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <!-- <adx-detail-slider class="detail-avod__banner__img"
      :slide="1" :isDetail="true" :isCenterMobile="false" :arrowMobile="false" :data="detailSlider" /> -->
      <adx-detail-slider :class="isPhotosAvailable ? 'detail-avod__banner__img' : 'detail-avod__banner__placeholder'"
      :slide="1" :isDetail="true" :isCenterMobile="false" :arrowMobile="false" :data="isPhotosAvailable ? detailSlider : placeholderImage" />
    </div>
    <!-- detail information -->
    <div v-if="!infoLoaded" class="loading-container">
      <adx-loading />
    </div>
    <!-- left detail content -->
    <div v-else class="detail-avod__info">
      <div class="detail-avod__info__left">
        <div class="detail-avod__info__left__header">
          <adx-label-custom class="label-airlines" :color="'#c283fa'" :label="'Airlines'"/>
          <h2 class="large-title">{{avodDetail.title}}</h2>
          <span class="detail-avod__info__left__header--placement subhead">{{channel_type}} • {{avodDetail.placement}}</span>
        </div>
        <div class="detail-avod__info__left__about">
          <div class="detail-avod__info__left__about__title">
            <h2 class="regular-font">Media Package</h2>
          </div>
          <div class="detail-avod__info__left__about__content">
            <p class="subhead">{{avodDetail.description}}</p>
          </div>
        </div>
        <!-- media details -->
        <!-- <div class="detail-avod__info__left__media"> -->
          <!-- <div class="detail-avod__info__left__media__title">
            <h2 class="regular-font">Media Details</h2>
          </div> -->
          <!-- <div class="detail-avod__info__left__media__content"> -->
            <!-- <div class="detail-avod__info__left__media__content--item" >
              <span>Duration <strong>{{ media.duration }}</strong></span>
            </div> -->
            <!-- <div class="detail-avod__info__left__media__content--item">
              <span>Cycle <strong>{{ media.cycle }} Month</strong></span>
            </div>
            <div class="detail-avod__info__left__media__content--item">
              <span>Minimum Order <strong>{{ media.min_order }} Month</strong></span>
            </div>
            <div class="detail-avod__info__left__media__content--item">
              <span>Skipable <strong>{{ media.skippable }}</strong></span>
            </div>
            <div class="detail-avod__info__left__media__content--item">
              <span>Placement <strong>{{ media.placement }}</strong></span>
            </div>
          </div>
        </div> -->
        <!-- about location -->
        <div class="detail-avod__info__left__about">
          <div class="detail-avod__info__left__about__title">
            <h2 class="regular-font">About Location</h2>
          </div>
          <div class="detail-avod__info__left__about__content">
            <p class="subhead">{{avodDetail.locDesc}}</p>
          </div>
        </div>
        <!-- traffic -->
        <!-- <div class="detail-avod__info__left__traffic">
          <div class="detail-avod__info__left__traffic__title">
            <h2 class="regular-font">Traffic</h2>
          </div>
          <div class="detail-avod__info__left__traffic__content">
            <span>Monthly Traffic : {{ getVisitor }} Visitors</span>
          </div> -->
          <!-- <div class="detail-avod__info__left__traffic__content" v-for="(demographic, index) in demographics" :key="index">
            <i :class="demographic.icon"></i>
            <span class="item">{{demographic.text}}</span>
          </div> -->
          <!-- <div class="detail-avod__info__left__traffic__content">
            <i class="adx-ic_cards"></i>
            <span class="item">Average Spending  {{traffic.spending | formatMoney}} {{traffic.subject}}</span>
          </div>
          <div class="detail-avod__info__left__traffic__content">
            <i class="adx-ic_briefcase"></i>
            <span class="item">{{traffic.occupation}}</span>
          </div>
          <div class="detail-avod__info__left__traffic__content">
            <i class="icon-knowledge-base"></i>
            <span class="item">{{traffic.visitor_profile}}</span>
          </div>
        </div> -->
      </div>
      <!-- right detail content -->
      <div class="detail-avod__info__right">
        <div class="detail-avod__info__right__price">
          <h4 class="subhead title">Price per month</h4>
          <h3 class="medium-title price">{{avodDetail.price|formatMoney}}</h3>
        </div>
        <div class="detail-avod__info__right__forbidden">
          <div class="detail-avod__info__right__forbidden--title">
            <i class="icon-warning"></i>
            <h3>Terms & Condition</h3>
          </div>
          <div class="detail-avod__info__right__forbidden--content">
            <p>{{avodDetail.terms_cons}}</p>
          </div>
        </div>
        <div class="detail-avod__info__right__action">
          <button class="btn-large primary add" @click="showCampaign">Add to Campaign</button>
        </div>
      </div>
    </div>
    <div v-if="infoLoaded" class="detail-avod__footer">
      <div class="detail-avod__footer__left">
        <p class="micro-font title">Price per month</p>
        <p class="medium-title price">{{avodDetail.price|formatMoney}}</p>
      </div>
      <div class="detail-avod__footer__right">
        <button class="btn-large btn-block primary" @click="showCampaign">Add to Campaign</button>
      </div>
    </div>
    <adx-modal v-if="isOpen" @modal-close="toggle" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="detailSlider" />
        <div class="modal__wrapper__footer">
          <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{avodDetail.title}}</span>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DetailSlider from '@/components/Slider/DetailSlider'
import Modal from '@/components/Modal'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import LoadingPrimary from '@/components/Loading/Primary'
import LabelStatus from '@/components/StatusLabel'
import CategoryJumbotron from '@/components/Jumbotron/Category'
import LabelStatusCustom from '@/components/StatusLabelCustom'
import api from '@/api'
import { airlinesParams } from '@/api/params'
import { apiV2 } from '@/api/urls'
import { formatNumber } from '@/lib/filter'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-avod',
  components: {
    'adx-detail-slider': DetailSlider,
    'adx-modal': Modal,
    'adx-loading-circle': LoadingSecondary,
    'adx-loading-spin': LoadingSpin,
    'adx-loading': LoadingPrimary,
    'label-status': LabelStatus,
    'category-jumbotron': CategoryJumbotron,
    'adx-label-custom': LabelStatusCustom
  },
  props: {

  },
  data() {
    return {
      channel_type:'Inflight',
      type:``,
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isCreateCampaign: false,
      isMobile: window.innerWidth < 769,
      isShownCampaign: false,
      campaigns: [],
      category: 'lifestyle',
      avodDetail: {
        title: ``,
        placement: ``,
        description: ``,
        surrounding: ``,
        terms_cons: ``,
        address: ``,
        price: null
      },
      media: {
        duration: null,
        cycle: null,
        min_order: null,
        skippable: ``,
        placement: ``,
      },
      traffic:{
        visitor: null,
        spending: null,
        subject: null,
        occupation: null,
        visitor_profile: null,
      },
      placeholderImage:[{
        id: 0,
        url: `/img/notfound/img-placeholder_landscape.jpg`,
        thumbnail : `/img/notfound/img-placeholder_landscape.jpg`,
        is_primary: false,
        caption: 'placeholder'
      }],
      detailSlider: [],
      isOpen: false,
      currentSlide: 1,
      countSlide: null,
      pub_id: null,
      deviceId: null,
      imgLoaded: false,
      infoLoaded: false,
      savedLoading: false,
      isAudienceDisplayed: null,
      params: null
    }
  },
  computed: {
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token'
    }),
    getVisitor: function() {
      return this.traffic.visitor * 30 
    },
    isPhotosAvailable(){
      return this.detailSlider.length > 0
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { pub_id } = this.$route.params
    this.pub_id = pub_id

    const categoryName = this.$options.name.split(`-`).pop()
    this.params = { ...airlinesParams[categoryName]}

    this.loadData()
    this.loadImage()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    showCampaign(){

    },
    loadData () {
      (async () => {
        const { data } = await api.get(apiV2.airlinesDetail(this.pub_id), { params: this.params , needToken: true })
        this.mapData(data)
        this.infoLoaded = true
      })();
    },
    loadImage () {
      (async () => {
        this.detailSlider = []
        const { data } = await api.get(apiV2.airlinesDetailImage(this.pub_id), {params: this.params, needToken: true })
        let isPrimaryExist = false
        let image = []
        data.map(el => {
          if(el.is_primary){
            isPrimaryExist = true
            image.push({
              id: el.id,
              url: el.image,
              thumbnail : el.thumbnail_720,
              is_primary: el.is_primary,
              caption: el.caption
            })
          }
        })
        this.imgLoaded = true
        if (!isPrimaryExist && data.length > 0){
          let firstPic = data[0]
          this.detailSlider.push({
            id: firstPic.id,
            url: firstPic.image,
            thumbnail : firstPic.thumbnail_720,
            is_primary: firstPic.is_primary,
            caption: firstPic.caption
          })
        } else if (image.length > 0 ){
          this.detailSlider.push(image[0])
        }
      })();
    },
    mapData (data) {
      this.avodDetail = {
        title: data.title,
        placement: data.placement,
        locDesc: data.location_inside.about,
        description: data.description,
        terms_cons: (data.terms_and_condition ? data.terms_and_condition : 'There\'s no Terms & Conditions'),
        price: data.price,
      }
      let purchaseResc = '-'
      if (data.purchase_restriction){
        purchaseResc = data.purchase_restriction.min_quantity + ' ' + data.purchase_restriction.min_period_type 
      }
      this.media = {
        duration: data.cycle + ` Second`,
        cycle: data.cycle + ' Month',
        min_order: purchaseResc,
        skippable: (data.skippable ? 'Yes' : 'No'),
        placement: data.placement,
      }
      this.traffic = {
        visitor: data.audience_daily,
        spending: (data.average_spending ? data.average_spending : 0),
        subject: '/' + data.period_spending_display + '/' + data.subject_spending_display,
        occupation: ` Occupation ${data.profile.ses.join(` `)}`,
        visitor_profile: ` Visitor Profile ${data.profile.ses.join(` `)}`,
      }
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    }
  }
}
</script>

<style lang="scss" scoped >
@import 'index';
@import '~@/styles/variables';
@import '~@/styles/mixins';

.modal__content .content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 10%;
}

@include breakpoint(md) {
  .modal__content .content {
    padding: 0 16px;
  }
}
.uppercase{
  text-transform: uppercase;
}
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.detail-avod__banner__placeholder {
  .slick-slide {
    img.detail {
      object-fit: unset;
    }
  }
}

.detail-avod__banner__img {
  .slick-slide {
    widows: 100;
  }
  .slick-slide:first-child{
    margin-left: 0px;
  }
}

@include breakpoint(md) {
  .detail-avod__banner__img {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
  .detail-avod__banner__placeholder {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
}
</style>

